import { Component } from '@angular/core';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { ImportOrganizationsComponent } from './import-organizations/import-organizations.component';
import { ImportOneRosterFileComponent } from './import-one-roster-file/import-one-roster-file.component';
import { ImportOneRosterJobComponent } from './import-one-roster-job/import-one-roster-job.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-import-data',
  standalone: true,
  imports: [
    NzTabsModule,
    ImportOrganizationsComponent,
    ImportOneRosterFileComponent,
    ImportOneRosterJobComponent,
    NzButtonModule,
    CommonModule,
  ],
  templateUrl: './import-data.component.html',
  styleUrl: './import-data.component.scss',
})
export class ImportDataComponent {}
